import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css'; 
import { Link } from 'react-router-dom';
import api from './api';

let LoginPage =(props) =>{
let  navigate = useNavigate();
let [user, setuser]=useState('');
let [pass, setpass]=useState('');
let [error, seterror]=useState('');
let [msg, setmsg]=useState(''); 
useEffect(()=>{
    let login = localStorage.getItem("login");
    if(login){
        navigate("../UserLogInPage"); 
    }
    let loginStatus = localStorage.getItem("loginStatus");
    if(loginStatus){
        seterror(loginStatus);
        setTimeout(function(){
            localStorage.clear(); 
            window.location.reload();
        }, 2000);
    }
    setTimeout(() => {
        setmsg("");
    }, 3000);
     
},[msg]);

  let handelchange=(e, type)=>{
   switch(type){
    case "email":
        seterror("");
        setuser(e.target.value);
        if(e.target.value === ""){
            seterror("Email id left blank");
           
        }
        break;
     case "pass":
        seterror("");
        setpass(e.target.value);
        if(e.target.value=== ""){
            seterror("Password left blank");
        }

   }
  }
  
let LogpageSubmitHandler= async()=>{
    if(user !== "" && pass !== ""){
        let formdata = new FormData();
        formdata.append("user" , user);
        formdata.append("password" , pass);
        const response = await api.post("/LoginPost.php", formdata)
        if(response.data[0].result === "Invalid Email-Id" || response.data[0].result === "Invalid Password" || response.data[0].result === "User Not Found!!! Please Registered First"){
                seterror(response.data[0].result);
                props.Successandrerrorfun("", response.data[0].result);
                 
        }else{
                setmsg(response.data[0].result);  
                props.datafinal(response.data[0].Data);
                if(response.data[0].JWT == undefined){
                    setmsg(response.data[0].result);
                    props.Successandrerrorfun(response.data[0].result, "");
                }else{
                     
                     setTimeout(function(){
                       localStorage.setItem("login", true);
                        localStorage.setItem("token" , response.data[0].JWT)
                }, 2000);
                }
        }
    }else{
        seterror("Both fildes are required"); 
         props.Successandrerrorfun("", "Both fildes are required");
        setTimeout(() => {
            seterror("");    
        }, 3000);
        
    }
}
    return(  
            <div className='loginpage_cont'>
                <div className='loging_heading_cont'>
                    <h2 className='log_heading'>Log In To Continue</h2> 
                </div>
                    <form className='inputs_cont'>
                        {
                            error !== "" ?
                            <p style={{textAlign: 'center', color: "red",margin:"0"}}>{error}</p> :
                            <p style={{textAlign: 'center', color: "green", margin:"0"}}>{msg}</p>
                        }
                        <input className='inputs_fields' value={user} onChange={(e)=>{handelchange(e, "email")}} type='email' name='Email' placeholder='Email-Id'/>


                        <input autoComplete='true'  type='password' name='Password'  className='inputs_fields' value={pass} onChange={(e)=>{handelchange(e, "pass")}} placeholder='Password'/>


                    </form>
                    <div className='submit_cont'>
                    <input
                       type='submit'
                       value="Login"
                       className='submit_btn hhhhh'
                       onClick={LogpageSubmitHandler}
                       />
                    </div>
                <div className='notice_board'>
                     
                    <ul>
                        <li><p className='instruction'>Log In Carefully</p></li>
                        <li><p className='instruction'> If  You Don't have Account Please click on sigh up.</p></li>
                        <li><p className='instruction'>If Any Trubble In Login CILCK ON Forgot Password</p></li> 
                    </ul>
                </div>
                <div style={{margin:"25px"}} className='forgot_signup_cont'>
                        <Link to='../forgotpassword'  className='forgot_link'>Forgot Password</Link>
                        {/* to='/forgotpassword' */}
                        <Link to='../SignUpPage' className='signup_link forgot_link'>SignUp</Link>  
                    </div>
                    
            </div>
            
        
    ); 
}
 
export default LoginPage;